import { FC } from 'react'
import { Trans } from 'react-i18next'

import { generateDateText } from 'services/Requests'
import { getUserName, getRequestTypeName } from 'services/Utilities'
import { t } from 'translations'

const TimeOffSummary: FC<MData.TimeOff> = ({ userId, start, end, vacationTypeId }) => {
  return (
    <Trans t={t} i18nKey={`manager.timeOffs.TIMEOFF_SUMMARY`}>
      <b>{{ name: getUserName(userId) }}</b>
      <b>{{ range: generateDateText(start, end, { partialOnlyTime: true }) }}</b>
      {{ requestTypeName: getRequestTypeName(vacationTypeId) }}
    </Trans>
  )
}

export default TimeOffSummary
